import {connect} from "react-redux";
import Modal from "../../../../components/Home/Pages/YourQuestions/Modal";
import {
setReasonOfUnsatisfiedResponse,
updateQuestion,
updateResponse
} from "../../../../actions/QuestionsAndAnswers";

const MapStateToProps = (state) => ({
reasonOfUnsatisfiedResponse: state.questionsAndAnswers.reasonOfUnsatisfiedResponse
});

const MapDispatchToProps = (dispatch) => ({
updateResponse: () => {
dispatch(updateResponse());
},
updateQuestion: (id, state, comment) => {
dispatch(updateQuestion(id, state, comment));
},
setReasonOfUnsatisfiedResponse: (value) => {
dispatch(setReasonOfUnsatisfiedResponse(value));
}
});

export default connect(MapStateToProps, MapDispatchToProps)(Modal);